$(function () {
    var target = document.querySelector("svg[data-name='Figure-3-desktop']");

    if (!target)
        return;

    var observer = new IntersectionObserver(function (entries) {
        entries.map(function (entry) {
            if (entry.isIntersecting) {
                $(entry.target).addClass("animate");
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    observer.observe(target);
});
